import React from 'react';
import classNames from 'classnames';
import { useSelector } from 'react-redux';
import styles from '../../styles.module.scss';
import balonUrl from '../../assets/Balon.png';
import flechaAbajoUrl from '../../assets/flechaabajo.png';

const getAssetUrl = (asset, primaryKey, secondaryKey) => {
  const primary = primaryKey ? asset?.[primaryKey] : null;
  const secondary = secondaryKey ? asset?.[secondaryKey] : null;
  const candidate = primary || secondary;
  return typeof candidate === 'string' && candidate.trim() ? candidate : null;
};

export function IconYellowCard() {
  const asset = useSelector((state) => state.asset);
  const iconUrl = getAssetUrl(asset, 'eventodeportivo_icono_amarilla_1', 'eventodeportivo_icono_amarilla_2');
  if (iconUrl) {
    return (
      <img
        className={styles['wca-lineaciones__wc-card']}
        src={iconUrl}
        alt=""
        width={8}
        height={12}
      />
    );
  }
  return (
    <span
      className={classNames(
        styles['wca-lineaciones__wc-card'],
        styles['wca-lineaciones__wc-card--yellow'],
      )}
      title="Tarjeta amarilla"
      aria-hidden
    />
  );
}

export function IconRedCard() {
  const asset = useSelector((state) => state.asset);
  const iconUrl = getAssetUrl(asset, 'eventodeportivo_icono_roja_1', 'eventodeportivo_icono_roja_2');
  if (iconUrl) {
    return (
      <img
        className={styles['wca-lineaciones__wc-card']}
        src={iconUrl}
        alt=""
        width={8}
        height={12}
      />
    );
  }
  return (
    <span
      className={classNames(styles['wca-lineaciones__wc-card'], styles['wca-lineaciones__wc-card--red'])}
      title="Tarjeta roja"
      aria-hidden
    />
  );
}

export function IconDiag2y() {
  const asset = useSelector((state) => state.asset);
  const iconUrl = getAssetUrl(
    asset,
    'eventodeportivo_icono_amarillaroja_1',
    'eventodeportivo_icono_amarillaroja_2',
  );
  if (iconUrl) {
    return (
      <img
        className={styles['wca-lineaciones__wc-card']}
        src={iconUrl}
        alt=""
        width={8}
        height={12}
      />
    );
  }
  return (
    <span
      className={classNames(styles['wca-lineaciones__wc-card'], styles['wca-lineaciones__wc-card--diag2y'])}
      title="Doble amarilla"
      aria-hidden
    />
  );
}

export function IconGoal({ n }) {
  const asset = useSelector((state) => state.asset);
  const iconUrl =
    getAssetUrl(asset, 'eventodeportivo_icono_gol_1', 'eventodeportivo_icono_gol_2') || balonUrl;
  const showGoalNumber = n != null && Number(n) >= 2;
  return (
    <span className={styles['wca-lineaciones__pl-evGoal']} title="Gol">
      <img
        className={styles['wca-lineaciones__pitch-player-iconImg']}
        src={iconUrl}
        alt=""
        width={12}
        height={12}
      />
      {showGoalNumber ? <span className={styles['wca-lineaciones__pl-goalN']}>{n}</span> : null}
    </span>
  );
}

export function IconSubOut() {
  const asset = useSelector((state) => state.asset);
  const iconUrl = getAssetUrl(asset, 'eventodeportivo_icono_sale') || flechaAbajoUrl;
  return (
    <span title="Cambio">
      <img
        className={styles['wca-lineaciones__pitch-player-iconImg']}
        src={iconUrl}
        alt=""
        width={12}
        height={12}
      />
    </span>
  );
}
